// extracted by mini-css-extract-plugin
module.exports = {"active":"CheckboxButton_active__sKG8N","inactive":"CheckboxButton_inactive__CbiEH"};